<template>
  <v-container class="main-container responsive-height">
    <v-row>
      <v-col md="6" sm="6" lg="4" v-for="method in methods" :key="method.id">
        <v-card class="elevation-0 rounded-0 transition-method-card"
          :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
          <v-card-actions class="paymentImage">
            <v-img height="155" contain :src="getMethodImage(method.method_name)" :alt="method.method_name">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-card-actions>
          <v-card-actions>
            <div class="value">
              <span>Method</span>
              <span>{{ method.method_name }}</span>
            </div>
            <v-spacer></v-spacer>
            <div class="value">
              <span>Currency</span>
              <span>{{ getCurrencyName(method.currency_id) }}</span>
            </div>
          </v-card-actions>
          <v-card-actions>
            <div class="value">
              <span>Processing Time</span>
              <span>{{ method.processing_time }}</span>
            </div>
            <v-spacer></v-spacer>
            <div class="value mr-6">
              <span>Fees</span>
              <span>${{ method.commission }}</span>
            </div>
          </v-card-actions>

          <v-card-actions class="pb-0 pt-3">
            <v-dialog transition="scale-transition" origin="center center" max-width="554"
              content-class="deposit-withdraw-popup">
              <template v-slot:activator="{ on, attrs }">
                <v-btn tile outlined elevation="0" class="text-capitalize btn-account" color="greenMain" v-bind="attrs"
                  v-on="on">Details</v-btn>
              </template>
              <template v-slot:default="dialog">
                <v-card class="rounded-0" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                  <v-card-title class="rounded-0">{{ method.method_name }} Detail</v-card-title>
                  <v-card-text>
                    <p>Currency: <span>{{ getCurrencyName(method.currency_id) }}</span></p>
                    <p>Fees / Commission: <span>${{ method.commission }}</span></p>
                    <p>Processing Time: <span>{{ method.processing_time }}</span></p>
                    <p v-if="method.beneficiary_name">Beneficiary Name: <span>{{ method.beneficiary_name }}</span></p>
                    <p v-if="method.beneficiary_address">Beneficiary Address: <span>{{ method.beneficiary_address
                        }}</span></p>
                    <p v-if="method.beneficiary_bank_name">Bank Name: <span>{{ method.beneficiary_bank_name }}</span>
                    </p>
                    <p v-if="method.beneficiary_bank_swift">SWIFT: <span>{{ method.beneficiary_bank_swift }}</span></p>
                  </v-card-text>
                  <ol>
                    <li>Payments from third parties are not accepted. The name of the sender must match the name on your
                      trading account.</li>
                    <li>The minimum transaction amount is ${{ method.min_transaction }}</li>
                    <li>The maximum transaction amount is ${{ formatMaxAmount(method.max_transaction) }}</li>
                    <li>Processing time is typically {{ method.processing_time }}. There may be delays if additional
                      verification is required.</li>
                  </ol>
                </v-card>
              </template>
            </v-dialog>

            <v-btn :to="getUrl(method)" tile elevation="0" class="text-capitalize btn-account"
              color="greenMain">Select</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { DEPOSITMETHODS__ACTIONS } from "@/store/action-types";

export default {
  data: () => ({
    methodImages: {
      'Bank Transfer': require("@/assets/payments/bank.png"),
      'Cash Transfer': require("@/assets/payments/cash.png"),
      'Crypto': require("@/assets/payments/crypto.png")
    },
    currencyMap: {
      1: 'USD',
      2: 'EUR',
      3: 'USDT'
    }
  }),
  computed: {
    ...mapState("deposit", ["methods"])
  },
  methods: {
    ...mapActions("deposit", [
      DEPOSITMETHODS__ACTIONS.DEPOSITMETHODS
    ]),
    getMethodImage(methodName) {
      return this.methodImages[methodName] || '';
    },
    getUrl(method) {
      return method.method_name === 'Bank Transfer' ? `/bank-deposit?payment_id=${method.id}` : method.method_name === 'Cash Transfer' ? `/cash-deposit?payment_id=${method.id}` : `/crypto-deposit?payment_id=${method.id}`
    },
    getCurrencyName(currencyId) {
      return this.currencyMap[currencyId] || 'USD';
    },
    formatMaxAmount(amount) {
      return Number(amount).toLocaleString();
    }
  },
  async mounted() {
    await this[DEPOSITMETHODS__ACTIONS.DEPOSITMETHODS]();
  }
};
</script>